import { z } from "zod";

export const VOICE_GUESSER_PHRASE_LOCALE = {
	FR: "fr",
	EN: "en",
} as const;

export const VOICE_GUESSER_PHRASE_LOCALE_VALUES = [VOICE_GUESSER_PHRASE_LOCALE.FR, VOICE_GUESSER_PHRASE_LOCALE.EN] as const;

export const voiceGuesserPhraseLocaleSchema = z.enum(VOICE_GUESSER_PHRASE_LOCALE_VALUES);
export type VoiceGuesserPhraseLocale = z.infer<typeof voiceGuesserPhraseLocaleSchema>;

export const VOICE_GUESSER_DEFAULT_PHRASE_LOCALE: VoiceGuesserPhraseLocale = VOICE_GUESSER_PHRASE_LOCALE.FR;
